import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LucideDynamicIcon, LucideIconInput } from '@lucide/angular';

export type IconSizes = 'xs' | 's' | 'sm' | 'm' | 'l' | 'xl' | 'xxl';

@Component({
  selector: 'ptl-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LucideDynamicIcon],
  // The Lucide SVG strokes with `currentColor`, so the icon follows the host's `color`. Drive that from the
  // `color` input, which defaults to the neutral colour these icons have always used (see `:host`).
  host: { '[style.color]': 'color()' },
})
export class IconComponent {
  icon = input.required<LucideIconInput>();
  size = input<IconSizes>('m');
  // Defaults to the neutral icon colour ($icon-neutral === --color-coldgrey-600, applied via `:host`);
  // pass a value to override.
  color = input<string>('var(--color-coldgrey-600)');
  strokeWidth = input<number>(1.5);

  protected readonly sizeMap: Record<IconSizes, number> = {
    xs: 16,
    s: 16,
    sm: 15,
    m: 20,
    l: 24,
    xl: 24,
    xxl: 80,
  };

  protected readonly resolvedSize = computed(() => this.sizeMap[this.size()]);
}
